import React from "react";
import { Column, Columns, Modal, Section, Table, Title } from "@allxsmith/bestax-bulma";


export default function InfoModal({show, setShow}){

    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={show}
            closeOnBlur
            onClose={() => setShow(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Column>
                            <Title>Info</Title>
                        </Column>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Table isBordered>
                                <tr>
                                    <td className={"table-highlight-dark-red"}></td>
                                    <td>The difference in days between book in date and workshop date is equal to or more than the warning days set in Settings</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-orange"}></td>
                                    <td>The difference in days between book in date and workshop date is equal to or more than the reminder days set in Settings</td>
                                </tr>
                                <tr>
                                    <td className={"table-highlight-green"}></td>
                                    <td>The vehicle has arrived</td>
                                </tr>
                            </Table>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );

}